module.exports = __webpack_public_path__ + "img/user-hair-buns.1669784d.svg";